import { useContext } from "react"
import { ParametrosAplicativoContext } from "./ParametrosAplicativoContext"

export function useParametrosAplicativoContext() {
    return useContext(ParametrosAplicativoContext)
}
